export default __webpack_public_path__ + "static/media/coin_2.37ba64fe.png";